//#region src/utils/isOddNumber.ts
function isOdd(number) {
	return Math.abs(number % 2) == 1;
}
//#endregion
export { isOdd };

//# sourceMappingURL=isOddNumber.js.map